import { Type } from "class-transformer";
import { Address, AddressInsert } from "./address";
import { Email, EmailInsert } from "./email";
import { Phone, PhoneInsert } from "./phone";

export interface IParty
{
    id: number;
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    middleInitial?:string;
    addresses: Address[];
    emails: Email[];
    phones: Phone[];
    optedInToStatusUpdates?: boolean;
}


export class Party implements IParty
{
    constructor
    (
        public id: number,
        public firstName:string,
        public lastName:string,
        public dateOfBirth: Date,
        public middleInitial?:string
    )
    {

    }
    

    @Type(() => Address)
    addresses: Address[] = [];

    @Type(() => Email)
    emails: Email[] = [];

    @Type(() => Phone)
    phones: Phone[] = [];

    optedInToStatusUpdates?: boolean;

    get fullName() : string
    {
        return this.firstName + " " + this.lastName;
    }

    get displayName() : string
    {
        return this.firstName + " " + this.lastName + " " + this.dateOfBirth.toLocaleDateString();
    }
}




export class PartyUpdate
{
    constructor
    (
        public id: number
    )
    {

    }

    firstName?:string;
    lastName?:string;
    dateOfBirth?: Date;
    middleInitial?:string;
    optedInToStatusUpdates?: boolean;
}

export class PartyInsert
{
    constructor
    (
        party: IParty
    )
    {
        this.firstName = party.firstName;
        this.lastName = party.lastName;
        this.dateOfBirth = party.dateOfBirth;
        this.middleInitial = party.middleInitial;
        this.addresses = party.addresses?.map(a => new AddressInsert(a));
        this.emails = party.emails?.map(e => new EmailInsert(e));
        this.phones = party.phones?.map(p => new PhoneInsert(p));
        this.optedInToStatusUpdates = party.optedInToStatusUpdates;

    }
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    middleInitial?: string;
    addresses?: AddressInsert[];
    emails?: EmailInsert[];
    phones?: PhoneInsert[];
    optedInToStatusUpdates?: boolean;
}